import Helmet from 'react-helmet'
import { I18nextProvider } from 'react-i18next'
import 'react-multi-carousel/lib/styles.css'
import { Provider } from 'react-redux'
import 'normalize.css'
import { GridThemeProvider, BaseCSS } from 'styled-bootstrap-grid'
import { grid, localization } from '@ocean/configs'
import { ThemeProvider } from '@ocean/theme'
import { general } from '@ocean/ui'
import store from 'store'
import Router from 'routing'
import 'assets/css/fonts.css'
import 'assets/css/global.css'

const { i18n } = localization
const { ToastContainer } = general

export const App: React.FC = ({ children }) => {
  const baseTitle = process.env.REACT_APP_TITLE

  return (
    <Provider store={store}>
      <BaseCSS />
      <I18nextProvider i18n={i18n}>
        <Helmet defaultTitle={baseTitle} titleTemplate={`%s - ${baseTitle}`} />
        <ThemeProvider>
          <ToastContainer />
          <GridThemeProvider gridTheme={grid.gridConfig}>
            <>{children}</>
          </GridThemeProvider>
        </ThemeProvider>
      </I18nextProvider>
    </Provider>
  )
}

const Root = () => {
  return (
    <App>
      <Router />
    </App>
  )
}

export default Root
